import type * as Types from '../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ViewerContigFragment = { id: number, name: string | null, description: string | null, accession: string, sequenceId: string, organism: { id: number, name: string | null, description: string | null, species: { name: string } | null } };

export type ViewerGenomeFragment = { id: number, name: string | null, description: string | null, species: { name: string } | null };

export type GetContigQueryVariables = Types.Exact<{
  contigId: Types.Scalars['Long']['input'];
}>;


export type GetContigQuery = { contig: { length: number, id: number, name: string | null, description: string | null, accession: string, sequenceId: string, organism: { hasGenomeAnalysis: boolean | null, hasVcfGenomeAnalysis: boolean | null, id: number, name: string | null, description: string | null, species: { name: string } | null } } | null };

export type GetGenomeStatisticsQueryVariables = Types.Exact<{
  genomeId: Types.Scalars['Long']['input'];
}>;


export type GetGenomeStatisticsQuery = { organism: { hasGenomeAnalysis: boolean | null, hasVcfGenomeAnalysis: boolean | null, genomeStatistics: { geneCount: number | null, proteinsCount: number | null, transcriptsCount: number | null, aaFeaturesCount: Array<{ count: number, featureTypeId: number, featureTypeName: string, featureTypeColor: string | null } | null> | null, nuFeaturesCount: Array<{ count: number | null, featureTypeId: number | null, featureTypeName: string | null, featureTypeColor: string | null } | null> | null, markersCount: Array<{ count: number | null, markerTypeId: number | null, markerTypeName: string | null } | null> | null, nuProfilesCount: Array<{ count: number | null, profileTypeId: number | null, profileTypeName: string | null } | null> | null } | null } };

export type GetContigStatisticsQueryVariables = Types.Exact<{
  contigId: Types.Scalars['Long']['input'];
}>;


export type GetContigStatisticsQuery = { contig: { length: number, contigStatistics: { contigSize: number | null, geneCount: number | null, proteinsCount: number | null, transcriptsCount: number | null, aaFeaturesCount: Array<{ count: number, featureTypeId: number, featureTypeName: string } | null> | null, nuFeaturesCount: Array<{ count: number | null, featureTypeId: number | null, featureTypeName: string | null, featureTypeColor: string | null } | null> | null, markersCount: Array<{ count: number | null, markerTypeId: number | null, markerTypeName: string | null } | null> | null, nuProfilesCount: Array<{ count: number | null, profileTypeName: string | null, profileTypeId: number | null } | null> | null } } | null };

export type SearchContigQueryVariables = Types.Exact<{
  searchTerm: Types.InputMaybe<Types.Scalars['String']['input']>;
  genomeId: Types.InputMaybe<Types.Scalars['Long']['input']>;
  limit: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SearchContigQuery = { search: { contigSearch: { contigs: Array<{ id: number, name: string | null, description: string | null, accession: string, sequenceId: string, organism: { id: number, name: string | null, description: string | null, species: { name: string } | null } }> } } };

export type SearchSequencedGenomeQueryVariables = Types.Exact<{
  searchTerm: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type SearchSequencedGenomeQuery = { search: { sequencedGenomes: { genomes: Array<{ id: number, name: string | null, description: string | null, species: { name: string } | null }> } } };

export type GetUserParamsTracksQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserParamsTracksQuery = { userParams: { showFlagsTrack: boolean | null, defaultTracks: Array<{ name: string | null, type: string | null, subTypeId: number | null, pinned: string | null, trackCustomization: { configuredPhenotypes: Array<{ id: number | null, idType: string | null, minValue: number | null, maxValue: number | null, logScale: boolean | null, colorScheme: { colors: Array<string | null> | null } | null } | null> | null } | null } | null> | null } | null };

export type UpdateUserParamsMutationVariables = Types.Exact<{
  userParams: Types.InputMaybe<Types.InputUserParamsInput>;
}>;


export type UpdateUserParamsMutation = { updateUserParams: { __typename: 'UserParams' } | null };

export type GetSavedViewQueryVariables = Types.Exact<{
  viewId: Types.Scalars['Long']['input'];
}>;


export type GetSavedViewQuery = { view: { id: number, type: string | null, name: string | null, description: string | null, owner: string | null, shared: boolean | null, deletable: boolean | null, created: string, typeDisplayName: string | null, deleted: boolean | null, version: number | null, viewType: string | null, viewLabel: string | null, params: string | null, project: { id: number, name: string, color: string | null, isPrivateWorkspace: boolean, isPublic: boolean, isUserAdmin: boolean } | null, creator: { id: number, username: string | null, firstName: string | null, lastName: string | null, email: string | null, display: string | null } | null, state: { genomeView: { hideFeatureTable: boolean | null, verticalLayout: boolean | null, showFlags: boolean | null, showCommunityAnnotation: boolean | null, headerWidth: number | null, variantExpressionFilters: string | null, featureTableRestriction: string | null, genome: { id: number, name: string | null, description: string | null, groupType: string, strain: string | null, genotypeDescription: string | null, isReference: boolean | null, hasGenomeAnalysis: boolean | null, hasVcfGenomeAnalysis: boolean | null, species: { id: number, name: string } | null, contigs: Array<{ id: number, name: string | null, accession: string, sequenceId: string, version: number, length: number, groupType: string, contigStatistics: { contigSize: number | null, geneCount: number | null, proteinsCount: number | null, transcriptsCount: number | null, markersCount: Array<{ markerTypeId: number | null, markerTypeName: string | null, count: number | null } | null> | null, nuFeaturesCount: Array<{ count: number | null, featureTypeId: number | null, featureTypeName: string | null } | null> | null, aaFeaturesCount: Array<{ associatedProteins: number, count: number, featureTypeId: number, featureTypeName: string } | null> | null } } | null> | null, userGroups: Array<{ id: number, name: string, description: string | null } | null> | null, genomeStatistics: { contigCount: number | null, geneCount: number | null, proteinsCount: number | null, transcriptsCount: number | null, flagCount: number | null, variantsCount: number | null, markersCount: Array<{ markerTypeId: number | null, markerTypeName: string | null, count: number | null } | null> | null, nuFeaturesCount: Array<{ count: number | null, featureTypeId: number | null, featureTypeName: string | null } | null> | null, aaFeaturesCount: Array<{ associatedProteins: number, count: number, featureTypeId: number, featureTypeName: string } | null> | null, nuProfilesCount: Array<{ count: number | null, profileTypeId: number | null, profileTypeName: string | null } | null> | null } | null } | null, contig: { id: number, name: string | null, accession: string, sequenceId: string, version: number, length: number, groupType: string, contigStatistics: { contigSize: number | null, geneCount: number | null, proteinsCount: number | null, transcriptsCount: number | null, markersCount: Array<{ markerTypeId: number | null, markerTypeName: string | null, count: number | null } | null> | null, nuFeaturesCount: Array<{ count: number | null, featureTypeId: number | null, featureTypeName: string | null } | null> | null, aaFeaturesCount: Array<{ associatedProteins: number, count: number, featureTypeId: number, featureTypeName: string } | null> | null } } | null, range: { start: number, stop: number } | null, tracks: Array<{ name: string | null, type: string | null, subTypeId: number | null, pinned: string | null, trackCustomization: { configuredPhenotypes: Array<{ id: number | null, idType: string | null, minValue: number | null, maxValue: number | null, logScale: boolean | null, colorScheme: { colors: Array<string | null> | null } | null, configuredTerms: Array<{ term: string | null, color: string | null } | null> | null } | null> | null, expressionColoring: { datasetId: number | null, conditions: Array<string | null> | null, minValue: number | null, maxValue: number | null, logScale: boolean | null, colorScheme: { colors: Array<string | null> | null } | null } | null, bedConfiguration: { orderedBedFiles: Array<{ bedFileId: number | null, color: string | null } | null> | null } | null, ngsConfiguration: { coverageConfig: { logScale: boolean | null, yAxisScaling: string | null, yAxisScalingMax: number | null, yAxisScalingMin: number | null } | null, orderedBamFiles: Array<{ bamFileId: number | null, visiblePileup: boolean | null, coverageColor: string | null, pileupDensity: string | null, pileupLanesCount: number | null, pileupColoring: string | null, pileupIncludeSoftClippedReads: boolean | null } | null> | null } | null } | null } | null> | null, orderedMutantGenomes: Array<{ id: number, name: string | null, description: string | null, species: { name: string } | null } | null> | null, tableView: { rowIds: Array<number | null> | null, selectedIds: Array<number | null> | null, totalRowCount: number | null, filteredRowCount: number | null, expansionPath: Array<string | null> | null, tableQuerySpec: { id: number | null, idType: string | null, queryType: string | null, resultType: string | null, resultSubTypeId: number | null, restrictions: { refGenomeId: number | null, variantGenomeIds: Array<number | null> | null } | null } | null, columns: Array<{ name: string | null, field: string | null, cellType: string | null, fixed: boolean | null, dynamic: boolean | null, dynamicType: string | null, sortable: boolean | null, filterable: boolean | null, hidden: boolean | null, columnId: number | null, namespace: number | null, groupName: string | null, groupField: string | null, filterExpression: string | null, cellExpansion: string | null, multiValuesContext: string | null, sort: { direction: string | null, priority: number | null } | null, searchAttributes: { field: string | null, name: string | null, groupName: string | null, description: string | null, cellType: string | null, minValue: number | null, maxValue: number | null, isInteger: boolean | null, values: Array<{ key: string | null, label: string | null } | null> | null, operators: Array<{ key: string | null, label: string | null } | null> | null } | null, attribute: { id: number, decimals: number | null, representedColumn: string | null, columnSet: { id: number | null }, attributeType: { id: number } } | null } | null> | null } | null, refGenome: { id: number, name: string | null, isReference: boolean | null } | null } | null, tableView: { rowIds: Array<number | null> | null, selectedIds: Array<number | null> | null, totalRowCount: number | null, filteredRowCount: number | null, expansionPath: Array<string | null> | null, tableQuerySpec: { id: number | null, idType: string | null, queryType: string | null, resultType: string | null, resultSubTypeId: number | null, restrictions: { refGenomeId: number | null, variantGenomeIds: Array<number | null> | null } | null } | null, columns: Array<{ name: string | null, field: string | null, cellType: string | null, fixed: boolean | null, dynamic: boolean | null, dynamicType: string | null, sortable: boolean | null, filterable: boolean | null, hidden: boolean | null, columnId: number | null, namespace: number | null, groupName: string | null, groupField: string | null, filterExpression: string | null, cellExpansion: string | null, multiValuesContext: string | null, sort: { direction: string | null, priority: number | null } | null, searchAttributes: { field: string | null, name: string | null, groupName: string | null, description: string | null, cellType: string | null, minValue: number | null, maxValue: number | null, isInteger: boolean | null, values: Array<{ key: string | null, label: string | null } | null> | null, operators: Array<{ key: string | null, label: string | null } | null> | null } | null, attribute: { id: number, decimals: number | null, representedColumn: string | null, columnSet: { id: number | null }, attributeType: { id: number } } | null } | null> | null } | null, blastView: { colorMismatchesOnly: boolean | null } | null, datasetView: { showFilterPanel: boolean | null, groupMode: boolean | null, chartSelection: Array<string | null> | null, chartTableSelection: Array<string | null> | null, dataset: { id: number | null, name: string | null, description: string | null, isGenomeDefault: boolean | null, isGlobalDefault: boolean | null, genomes: Array<{ id: number, name: string | null, description: string | null, groupType: string, strain: string | null, genotypeDescription: string | null, species: { id: number, name: string } | null } | null> | null, columns: Array<{ name: string | null, field: string | null, minValue: number | null, maxValue: number | null, annotations: Array<{ key: string | null, value: string | null, multiValueIndex: string | null } | null> | null } | null> | null, columnAnnotations: Array<{ name: string | null, field: string | null, type: string | null, valueSet: Array<string | null> | null, values: Array<{ key: string | null, label: string | null, value: string | null, multiValueIndex: string | null } | null> | null } | null> | null, rowAnnotations: Array<{ name: string | null, field: string | null, type: string | null } | null> | null } | null, selectedAnnotations: Array<{ label: string | null, conditionValues: Array<string | null> | null } | null> | null, dataSeries: Array<{ name: string | null, rows: Array<{ id: string | null, values: Array<{ key: string | null, value: string | null, multiValueIndex: string | null } | null> | null } | null> | null } | null> | null, selectedDataSeries: Array<{ name: string | null, color: string | null, hidden: boolean | null, splitByCondition: string | null, splitParent: string | null, splitValue: string | null, splitMultiValueIndex: string | null } | null> | null, chartLayout: { chartType: string | null, isLogScale: boolean | null, timeSeries: boolean | null, errorBars: boolean | null, filterOutEmptyValues: boolean | null, symbolSize: number | null } | null, filteredOutAnnotations: Array<{ name: string | null, categoricalValues: Array<string | null> | null, minNumericalValue: number | null, maxNumericalValue: number | null } | null> | null, splitPaneLayout: { verticalLayout: boolean | null, hidden: boolean | null, size: number | null } | null, groupTableView: { rowIds: Array<number | null> | null, selectedIds: Array<number | null> | null, totalRowCount: number | null, filteredRowCount: number | null, expansionPath: Array<string | null> | null, tableQuerySpec: { id: number | null, idType: string | null, queryType: string | null, resultType: string | null, resultSubTypeId: number | null, restrictions: { refGenomeId: number | null, variantGenomeIds: Array<number | null> | null } | null } | null, columns: Array<{ name: string | null, field: string | null, cellType: string | null, fixed: boolean | null, dynamic: boolean | null, dynamicType: string | null, sortable: boolean | null, filterable: boolean | null, hidden: boolean | null, columnId: number | null, namespace: number | null, groupName: string | null, groupField: string | null, filterExpression: string | null, cellExpansion: string | null, multiValuesContext: string | null, sort: { direction: string | null, priority: number | null } | null, searchAttributes: { field: string | null, name: string | null, groupName: string | null, description: string | null, cellType: string | null, minValue: number | null, maxValue: number | null, isInteger: boolean | null, values: Array<{ key: string | null, label: string | null } | null> | null, operators: Array<{ key: string | null, label: string | null } | null> | null } | null, attribute: { id: number, decimals: number | null, representedColumn: string | null, columnSet: { id: number | null }, attributeType: { id: number } } | null } | null> | null } | null } | null, contentBrowserView: { groupByAttribute: string | null, selectedEntry: { columnField: string | null, key: string | null, label: string | null, value: number | null, tableFilter: string | null } | null, tableView: { rowIds: Array<number | null> | null, selectedIds: Array<number | null> | null, totalRowCount: number | null, filteredRowCount: number | null, expansionPath: Array<string | null> | null, tableQuerySpec: { id: number | null, idType: string | null, queryType: string | null, resultType: string | null, resultSubTypeId: number | null, restrictions: { refGenomeId: number | null, variantGenomeIds: Array<number | null> | null } | null } | null, columns: Array<{ name: string | null, field: string | null, cellType: string | null, fixed: boolean | null, dynamic: boolean | null, dynamicType: string | null, sortable: boolean | null, filterable: boolean | null, hidden: boolean | null, columnId: number | null, namespace: number | null, groupName: string | null, groupField: string | null, filterExpression: string | null, cellExpansion: string | null, multiValuesContext: string | null, sort: { direction: string | null, priority: number | null } | null, searchAttributes: { field: string | null, name: string | null, groupName: string | null, description: string | null, cellType: string | null, minValue: number | null, maxValue: number | null, isInteger: boolean | null, values: Array<{ key: string | null, label: string | null } | null> | null, operators: Array<{ key: string | null, label: string | null } | null> | null } | null, attribute: { id: number, decimals: number | null, representedColumn: string | null, columnSet: { id: number | null }, attributeType: { id: number } } | null } | null> | null } | null } | null, summaryView: { refGenomeId: number | null } | null } | null } | null };

export const ViewerGenomeFragmentDoc = gql`
    fragment viewerGenome on Organism {
  id
  name
  description
  species {
    name
  }
}
    `;
export const ViewerContigFragmentDoc = gql`
    fragment viewerContig on Contig {
  id
  name
  description
  accession
  sequenceId
  organism {
    ...viewerGenome
  }
}
    ${ViewerGenomeFragmentDoc}`;
export const GetContigDocument = gql`
    query getContig($contigId: Long!) {
  contig(contigId: $contigId) {
    ...viewerContig
    length
    organism {
      hasGenomeAnalysis
      hasVcfGenomeAnalysis
    }
  }
}
    ${ViewerContigFragmentDoc}`;

/**
 * __useGetContigQuery__
 *
 * To run a query within a React component, call `useGetContigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContigQuery({
 *   variables: {
 *      contigId: // value for 'contigId'
 *   },
 * });
 */
export function useGetContigQuery(baseOptions: Apollo.QueryHookOptions<GetContigQuery, GetContigQueryVariables> & ({ variables: GetContigQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContigQuery, GetContigQueryVariables>(GetContigDocument, options);
      }
export function useGetContigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContigQuery, GetContigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContigQuery, GetContigQueryVariables>(GetContigDocument, options);
        }
export function useGetContigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContigQuery, GetContigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContigQuery, GetContigQueryVariables>(GetContigDocument, options);
        }
export type GetContigQueryHookResult = ReturnType<typeof useGetContigQuery>;
export type GetContigLazyQueryHookResult = ReturnType<typeof useGetContigLazyQuery>;
export type GetContigSuspenseQueryHookResult = ReturnType<typeof useGetContigSuspenseQuery>;
export type GetContigQueryResult = Apollo.QueryResult<GetContigQuery, GetContigQueryVariables>;
export const GetGenomeStatisticsDocument = gql`
    query getGenomeStatistics($genomeId: Long!) {
  organism(organismId: $genomeId) {
    hasGenomeAnalysis
    hasVcfGenomeAnalysis
    genomeStatistics {
      geneCount
      proteinsCount
      transcriptsCount
      aaFeaturesCount {
        count
        featureTypeId
        featureTypeName
        featureTypeColor
      }
      nuFeaturesCount {
        count
        featureTypeId
        featureTypeName
        featureTypeColor
      }
      markersCount {
        count
        markerTypeId
        markerTypeName
      }
      nuProfilesCount {
        count
        profileTypeId
        profileTypeName
      }
    }
  }
}
    `;

/**
 * __useGetGenomeStatisticsQuery__
 *
 * To run a query within a React component, call `useGetGenomeStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenomeStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenomeStatisticsQuery({
 *   variables: {
 *      genomeId: // value for 'genomeId'
 *   },
 * });
 */
export function useGetGenomeStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables> & ({ variables: GetGenomeStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables>(GetGenomeStatisticsDocument, options);
      }
export function useGetGenomeStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables>(GetGenomeStatisticsDocument, options);
        }
export function useGetGenomeStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables>(GetGenomeStatisticsDocument, options);
        }
export type GetGenomeStatisticsQueryHookResult = ReturnType<typeof useGetGenomeStatisticsQuery>;
export type GetGenomeStatisticsLazyQueryHookResult = ReturnType<typeof useGetGenomeStatisticsLazyQuery>;
export type GetGenomeStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetGenomeStatisticsSuspenseQuery>;
export type GetGenomeStatisticsQueryResult = Apollo.QueryResult<GetGenomeStatisticsQuery, GetGenomeStatisticsQueryVariables>;
export const GetContigStatisticsDocument = gql`
    query getContigStatistics($contigId: Long!) {
  contig(contigId: $contigId) {
    length
    contigStatistics {
      contigSize
      geneCount
      proteinsCount
      transcriptsCount
      aaFeaturesCount {
        count
        featureTypeId
        featureTypeName
      }
      nuFeaturesCount {
        count
        featureTypeId
        featureTypeName
        featureTypeColor
      }
      markersCount {
        count
        markerTypeId
        markerTypeName
      }
      nuProfilesCount {
        count
        profileTypeName
        profileTypeId
      }
    }
  }
}
    `;

/**
 * __useGetContigStatisticsQuery__
 *
 * To run a query within a React component, call `useGetContigStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContigStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContigStatisticsQuery({
 *   variables: {
 *      contigId: // value for 'contigId'
 *   },
 * });
 */
export function useGetContigStatisticsQuery(baseOptions: Apollo.QueryHookOptions<GetContigStatisticsQuery, GetContigStatisticsQueryVariables> & ({ variables: GetContigStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContigStatisticsQuery, GetContigStatisticsQueryVariables>(GetContigStatisticsDocument, options);
      }
export function useGetContigStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContigStatisticsQuery, GetContigStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContigStatisticsQuery, GetContigStatisticsQueryVariables>(GetContigStatisticsDocument, options);
        }
export function useGetContigStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContigStatisticsQuery, GetContigStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContigStatisticsQuery, GetContigStatisticsQueryVariables>(GetContigStatisticsDocument, options);
        }
export type GetContigStatisticsQueryHookResult = ReturnType<typeof useGetContigStatisticsQuery>;
export type GetContigStatisticsLazyQueryHookResult = ReturnType<typeof useGetContigStatisticsLazyQuery>;
export type GetContigStatisticsSuspenseQueryHookResult = ReturnType<typeof useGetContigStatisticsSuspenseQuery>;
export type GetContigStatisticsQueryResult = Apollo.QueryResult<GetContigStatisticsQuery, GetContigStatisticsQueryVariables>;
export const SearchContigDocument = gql`
    query searchContig($searchTerm: String, $genomeId: Long, $limit: Int) {
  search {
    contigSearch(searchTerm: $searchTerm, genomeId: $genomeId, limit: $limit) {
      contigs {
        ...viewerContig
      }
    }
  }
}
    ${ViewerContigFragmentDoc}`;

/**
 * __useSearchContigQuery__
 *
 * To run a query within a React component, call `useSearchContigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContigQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      genomeId: // value for 'genomeId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchContigQuery(baseOptions?: Apollo.QueryHookOptions<SearchContigQuery, SearchContigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContigQuery, SearchContigQueryVariables>(SearchContigDocument, options);
      }
export function useSearchContigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContigQuery, SearchContigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContigQuery, SearchContigQueryVariables>(SearchContigDocument, options);
        }
export function useSearchContigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchContigQuery, SearchContigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchContigQuery, SearchContigQueryVariables>(SearchContigDocument, options);
        }
export type SearchContigQueryHookResult = ReturnType<typeof useSearchContigQuery>;
export type SearchContigLazyQueryHookResult = ReturnType<typeof useSearchContigLazyQuery>;
export type SearchContigSuspenseQueryHookResult = ReturnType<typeof useSearchContigSuspenseQuery>;
export type SearchContigQueryResult = Apollo.QueryResult<SearchContigQuery, SearchContigQueryVariables>;
export const SearchSequencedGenomeDocument = gql`
    query searchSequencedGenome($searchTerm: String, $limit: Int) {
  search {
    sequencedGenomes(searchTerm: $searchTerm, limit: $limit) {
      genomes {
        ...viewerGenome
      }
    }
  }
}
    ${ViewerGenomeFragmentDoc}`;

/**
 * __useSearchSequencedGenomeQuery__
 *
 * To run a query within a React component, call `useSearchSequencedGenomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSequencedGenomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSequencedGenomeQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchSequencedGenomeQuery(baseOptions?: Apollo.QueryHookOptions<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>(SearchSequencedGenomeDocument, options);
      }
export function useSearchSequencedGenomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>(SearchSequencedGenomeDocument, options);
        }
export function useSearchSequencedGenomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>(SearchSequencedGenomeDocument, options);
        }
export type SearchSequencedGenomeQueryHookResult = ReturnType<typeof useSearchSequencedGenomeQuery>;
export type SearchSequencedGenomeLazyQueryHookResult = ReturnType<typeof useSearchSequencedGenomeLazyQuery>;
export type SearchSequencedGenomeSuspenseQueryHookResult = ReturnType<typeof useSearchSequencedGenomeSuspenseQuery>;
export type SearchSequencedGenomeQueryResult = Apollo.QueryResult<SearchSequencedGenomeQuery, SearchSequencedGenomeQueryVariables>;
export const GetUserParamsTracksDocument = gql`
    query getUserParamsTracks {
  userParams {
    showFlagsTrack
    defaultTracks {
      name
      type
      subTypeId
      pinned
      trackCustomization {
        configuredPhenotypes {
          id
          idType
          minValue
          maxValue
          logScale
          colorScheme {
            colors
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUserParamsTracksQuery__
 *
 * To run a query within a React component, call `useGetUserParamsTracksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserParamsTracksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserParamsTracksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserParamsTracksQuery(baseOptions?: Apollo.QueryHookOptions<GetUserParamsTracksQuery, GetUserParamsTracksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserParamsTracksQuery, GetUserParamsTracksQueryVariables>(GetUserParamsTracksDocument, options);
      }
export function useGetUserParamsTracksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserParamsTracksQuery, GetUserParamsTracksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserParamsTracksQuery, GetUserParamsTracksQueryVariables>(GetUserParamsTracksDocument, options);
        }
export function useGetUserParamsTracksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserParamsTracksQuery, GetUserParamsTracksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserParamsTracksQuery, GetUserParamsTracksQueryVariables>(GetUserParamsTracksDocument, options);
        }
export type GetUserParamsTracksQueryHookResult = ReturnType<typeof useGetUserParamsTracksQuery>;
export type GetUserParamsTracksLazyQueryHookResult = ReturnType<typeof useGetUserParamsTracksLazyQuery>;
export type GetUserParamsTracksSuspenseQueryHookResult = ReturnType<typeof useGetUserParamsTracksSuspenseQuery>;
export type GetUserParamsTracksQueryResult = Apollo.QueryResult<GetUserParamsTracksQuery, GetUserParamsTracksQueryVariables>;
export const UpdateUserParamsDocument = gql`
    mutation updateUserParams($userParams: InputUserParamsInput) {
  updateUserParams(userParams: $userParams) {
    __typename
  }
}
    `;
export type UpdateUserParamsMutationFn = Apollo.MutationFunction<UpdateUserParamsMutation, UpdateUserParamsMutationVariables>;

/**
 * __useUpdateUserParamsMutation__
 *
 * To run a mutation, you first call `useUpdateUserParamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserParamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserParamsMutation, { data, loading, error }] = useUpdateUserParamsMutation({
 *   variables: {
 *      userParams: // value for 'userParams'
 *   },
 * });
 */
export function useUpdateUserParamsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserParamsMutation, UpdateUserParamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserParamsMutation, UpdateUserParamsMutationVariables>(UpdateUserParamsDocument, options);
      }
export type UpdateUserParamsMutationHookResult = ReturnType<typeof useUpdateUserParamsMutation>;
export type UpdateUserParamsMutationResult = Apollo.MutationResult<UpdateUserParamsMutation>;
export type UpdateUserParamsMutationOptions = Apollo.BaseMutationOptions<UpdateUserParamsMutation, UpdateUserParamsMutationVariables>;
export const GetSavedViewDocument = gql`
    query getSavedView($viewId: Long!) {
  view(viewId: $viewId) {
    id
    type
    name
    description
    owner
    project {
      id
      name
      color
    }
    shared
    deletable
    created
    typeDisplayName
    project {
      isPrivateWorkspace
      isPublic
      isUserAdmin
    }
    creator {
      id
      username
      firstName
      lastName
      email
      display
    }
    deleted
    version
    viewType
    viewLabel
    params
    state {
      genomeView {
        genome {
          id
          name
          description
          groupType
          strain
          genotypeDescription
          species {
            id
            name
          }
          isReference
          hasGenomeAnalysis
          hasVcfGenomeAnalysis
          contigs(limit: 1) {
            id
            name
            accession
            sequenceId
            version
            length
            groupType
            contigStatistics {
              contigSize
              geneCount
              proteinsCount
              transcriptsCount
              markersCount {
                markerTypeId
                markerTypeName
                count
              }
              nuFeaturesCount {
                count
                featureTypeId
                featureTypeName
              }
              aaFeaturesCount {
                associatedProteins
                count
                featureTypeId
                featureTypeName
              }
            }
          }
          userGroups {
            id
            name
            description
          }
          genomeStatistics {
            contigCount
            geneCount
            proteinsCount
            transcriptsCount
            flagCount
            variantsCount
            markersCount {
              markerTypeId
              markerTypeName
              count
            }
            nuFeaturesCount {
              count
              featureTypeId
              featureTypeName
            }
            aaFeaturesCount {
              associatedProteins
              count
              featureTypeId
              featureTypeName
            }
            nuProfilesCount {
              count
              profileTypeId
              profileTypeName
            }
          }
        }
        contig {
          id
          name
          accession
          sequenceId
          version
          length
          groupType
          contigStatistics {
            contigSize
            geneCount
            proteinsCount
            transcriptsCount
            markersCount {
              markerTypeId
              markerTypeName
              count
            }
            nuFeaturesCount {
              count
              featureTypeId
              featureTypeName
            }
            aaFeaturesCount {
              associatedProteins
              count
              featureTypeId
              featureTypeName
            }
          }
        }
        range {
          start
          stop
        }
        tracks {
          name
          type
          subTypeId
          pinned
          trackCustomization {
            configuredPhenotypes {
              id
              idType
              minValue
              maxValue
              logScale
              colorScheme {
                colors
              }
              configuredTerms {
                term
                color
              }
            }
            expressionColoring {
              datasetId
              conditions
              minValue
              maxValue
              logScale
              colorScheme {
                colors
              }
            }
            bedConfiguration {
              orderedBedFiles {
                bedFileId
                color
              }
            }
            ngsConfiguration {
              coverageConfig {
                logScale
                yAxisScaling
                yAxisScalingMax
                yAxisScalingMin
              }
              orderedBamFiles {
                bamFileId
                visiblePileup
                coverageColor
                pileupDensity
                pileupLanesCount
                pileupColoring
                pileupIncludeSoftClippedReads
              }
            }
          }
        }
        hideFeatureTable
        verticalLayout
        showFlags
        showCommunityAnnotation
        headerWidth
        variantExpressionFilters
        orderedMutantGenomes {
          ...viewerGenome
        }
        featureTableRestriction
        tableView {
          rowIds
          selectedIds
          totalRowCount
          filteredRowCount
          expansionPath
          tableQuerySpec {
            id
            idType
            queryType
            resultType
            resultSubTypeId
            restrictions {
              refGenomeId
              variantGenomeIds
            }
          }
          columns {
            name
            field
            cellType
            fixed
            dynamic
            dynamicType
            sort {
              direction
              priority
            }
            sortable
            filterable
            hidden
            columnId
            namespace
            groupName
            groupField
            filterExpression
            cellExpansion
            multiValuesContext
            searchAttributes {
              field
              name
              groupName
              description
              cellType
              values {
                key
                label
              }
              operators {
                key
                label
              }
              minValue
              maxValue
              isInteger
            }
            attribute {
              id
              decimals
              columnSet {
                id
              }
              representedColumn
              attributeType {
                id
              }
            }
          }
        }
        refGenome {
          id
          name
          isReference
        }
      }
      tableView {
        rowIds
        selectedIds
        totalRowCount
        filteredRowCount
        expansionPath
        tableQuerySpec {
          id
          idType
          queryType
          resultType
          resultSubTypeId
          restrictions {
            refGenomeId
            variantGenomeIds
          }
        }
        columns {
          name
          field
          cellType
          fixed
          dynamic
          dynamicType
          sort {
            direction
            priority
          }
          sortable
          filterable
          hidden
          columnId
          namespace
          groupName
          groupField
          filterExpression
          cellExpansion
          multiValuesContext
          searchAttributes {
            field
            name
            groupName
            description
            cellType
            values {
              key
              label
            }
            operators {
              key
              label
            }
            minValue
            maxValue
            isInteger
          }
          attribute {
            id
            decimals
            columnSet {
              id
            }
            representedColumn
            attributeType {
              id
            }
          }
        }
      }
      blastView {
        colorMismatchesOnly
      }
      datasetView {
        dataset {
          id
          name
          description
          isGenomeDefault
          isGlobalDefault
          genomes {
            id
            name
            description
            groupType
            strain
            genotypeDescription
            species {
              id
              name
            }
          }
          columns {
            name
            field
            annotations {
              key
              value
              multiValueIndex
            }
            minValue
            maxValue
          }
          columnAnnotations {
            name
            field
            type
            valueSet
            values {
              key
              label
              value
              multiValueIndex
            }
          }
          rowAnnotations {
            name
            field
            type
          }
        }
        selectedAnnotations {
          label
          conditionValues
        }
        dataSeries {
          name
          rows {
            id
            values {
              key
              value
              multiValueIndex
            }
          }
        }
        selectedDataSeries {
          name
          color
          hidden
          splitByCondition
          splitParent
          splitValue
          splitMultiValueIndex
        }
        chartLayout {
          chartType
          isLogScale
          timeSeries
          errorBars
          filterOutEmptyValues
          symbolSize
        }
        showFilterPanel
        filteredOutAnnotations {
          name
          categoricalValues
          minNumericalValue
          maxNumericalValue
        }
        groupMode
        chartSelection
        chartTableSelection
        splitPaneLayout {
          verticalLayout
          hidden
          size
        }
        groupTableView {
          rowIds
          selectedIds
          totalRowCount
          filteredRowCount
          expansionPath
          tableQuerySpec {
            id
            idType
            queryType
            resultType
            resultSubTypeId
            restrictions {
              refGenomeId
              variantGenomeIds
            }
          }
          columns {
            name
            field
            cellType
            fixed
            dynamic
            dynamicType
            sort {
              direction
              priority
            }
            sortable
            filterable
            hidden
            columnId
            namespace
            groupName
            groupField
            filterExpression
            cellExpansion
            multiValuesContext
            searchAttributes {
              field
              name
              groupName
              description
              cellType
              values {
                key
                label
              }
              operators {
                key
                label
              }
              minValue
              maxValue
              isInteger
            }
            attribute {
              id
              decimals
              columnSet {
                id
              }
              representedColumn
              attributeType {
                id
              }
            }
          }
        }
      }
      contentBrowserView {
        groupByAttribute
        selectedEntry {
          columnField
          key
          label
          value
          tableFilter
        }
        tableView {
          rowIds
          selectedIds
          totalRowCount
          filteredRowCount
          expansionPath
          tableQuerySpec {
            id
            idType
            queryType
            resultType
            resultSubTypeId
            restrictions {
              refGenomeId
              variantGenomeIds
            }
          }
          columns {
            name
            field
            cellType
            fixed
            dynamic
            dynamicType
            sort {
              direction
              priority
            }
            sortable
            filterable
            hidden
            columnId
            namespace
            groupName
            groupField
            filterExpression
            cellExpansion
            multiValuesContext
            searchAttributes {
              field
              name
              groupName
              description
              cellType
              values {
                key
                label
              }
              operators {
                key
                label
              }
              minValue
              maxValue
              isInteger
            }
            attribute {
              id
              decimals
              columnSet {
                id
              }
              representedColumn
              attributeType {
                id
              }
            }
          }
        }
      }
      summaryView {
        refGenomeId
      }
    }
  }
}
    ${ViewerGenomeFragmentDoc}`;

/**
 * __useGetSavedViewQuery__
 *
 * To run a query within a React component, call `useGetSavedViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedViewQuery({
 *   variables: {
 *      viewId: // value for 'viewId'
 *   },
 * });
 */
export function useGetSavedViewQuery(baseOptions: Apollo.QueryHookOptions<GetSavedViewQuery, GetSavedViewQueryVariables> & ({ variables: GetSavedViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedViewQuery, GetSavedViewQueryVariables>(GetSavedViewDocument, options);
      }
export function useGetSavedViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedViewQuery, GetSavedViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedViewQuery, GetSavedViewQueryVariables>(GetSavedViewDocument, options);
        }
export function useGetSavedViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSavedViewQuery, GetSavedViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSavedViewQuery, GetSavedViewQueryVariables>(GetSavedViewDocument, options);
        }
export type GetSavedViewQueryHookResult = ReturnType<typeof useGetSavedViewQuery>;
export type GetSavedViewLazyQueryHookResult = ReturnType<typeof useGetSavedViewLazyQuery>;
export type GetSavedViewSuspenseQueryHookResult = ReturnType<typeof useGetSavedViewSuspenseQuery>;
export type GetSavedViewQueryResult = Apollo.QueryResult<GetSavedViewQuery, GetSavedViewQueryVariables>;